
import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { DemReservePerspective } from '@/gtn/org/dem/entities/reserve/DemReservePerspective';
import { Route } from 'react-router-dom';
import { DemFinanceDashboard } from './entities/financeDashboard/DemFinanceDashboard';
import { DemForecastDetail } from './entities/forecast/DemForecastDetail';
import { DemMcoPymtPerspective } from './entities/mcoPymt/DemMcoPymtPerspective';
import { DemReconPerspective } from './entities/recon/DemReconPerspective';
import { DemReconDashboard } from './entities/reconDashboard/DemReconDashboard';
import { DemSbcPerspective } from './entities/sbc/DemSbcPerspective';

const demGtnRoutes = [
  <Route path="/gtn/recon" element={<EntityView perspectiveComponent={DemReconPerspective} />} />,
  <Route path="/gtn/reserve" element={<EntityView perspectiveComponent={DemReservePerspective} />} />,
  <Route path="/gtn/sbc" element={<EntityView perspectiveComponent={DemSbcPerspective} />} />,
  <Route path="/gtn/mco-pymt" element={<EntityView perspectiveComponent={DemMcoPymtPerspective} />} />,
  <Route path="/gtn/forecast" element={<EntityView detailComponent={DemForecastDetail} />} />,
  <Route path="/gtn/dashboard/finance" element={<DemFinanceDashboard />} />,
  <Route path="/gtn/dashboard/recon" element={<DemReconDashboard />} />,
  <Route path="/gtn/action" element={<EntityView />} />,
  <Route path="/gtn/accr-rate" element={<EntityView />} />
]

export default demGtnRoutes;